define('boxes/controllers/deposit-controller',['jquery', 'boxes/controllers/box-controller', 'boxes/pending-withdraws-box', 'boxes/deposit-bonus/deposit-bonus-box', 'boxes/email-verification-box', 'boxes/mobile-verification-box', 'boxes/deposit-box', 'boxes/deposit-result-box', 'boxes/events/bonus-event', 'boxes/events/paymentEvent', 'all/tracking-event', 'payment/getPaymentResult', 'boxes/controllers/login-controller', 'all/player/session'], function ($, boxController, pendingWithdrawsBox, depositBonusBox, emailVerificationBox, mobileVerificationBox, depositBox, depositResultBox, bonusEvent, paymentEvent, trackingEvent, getPaymentResult, loginController, session) {
    'use strict';
    var controller = boxController.create('.deposit.controller'),
        depositBonus;

    function start(startIndex) {

		$.ajax({
			type: 'post',
			url: '/PaymentFormDataService/formEvent/playerEnterForm',
			data: JSON.stringify({deposit: true, mobileDevice: false}),
			contentType: "application/json",
			success: function (data) {
				console.info('player entered deposit form');
			}
		});

        controller.start(setup, startIndex);
        getPaymentResult.start(controller);
        if(window.instantdeposit !== undefined){
            window.instantdeposit.addListener(instantDepositTransactionExecuted);
        }
        return controller;
    }

    function setup() {
        var $boxes = controller.find('.boxes');

        depositBonus = depositBonusBox.create($boxes.find('.box.deposit-bonus'), controller);

        controller.setBoxes([
            pendingWithdrawsBox.create($boxes.find('.box.pending-withdraws.deposit-type'), controller),
            depositBonus,
            emailVerificationBox.create($boxes.find('.box.email-verification'), controller, 'deposit'),
            mobileVerificationBox.create($boxes.find('.box.mobile-verification'), controller),
            depositBox.create($boxes.find('.box.deposit'), controller),
            depositResultBox.create($boxes.find('.box.deposit-result'), controller)
        ]);
    }

    function instantDepositTransactionExecuted(transactionStatusConst){
        if(transactionStatusConst === 2){
            controller.trigger(paymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED);
        }
    }

    function selectBonus(bonusId) {
        $.post('/pp?flow=GetDepositBonuses', {bonusId: bonusId, includeFreeBonuses: true, includeShop: true}, function (responseData) {
            if(responseData.bonuses !== undefined && responseData.bonuses[0] !== undefined){
                var bonus = responseData.bonuses[0];

                controller.trigger(bonusEvent.BONUS_CHANGED, {
                    id: bonus.id,
                    title: bonus.header,
                    description: bonus.description,
                    resourceUrl: (bonus.extraLargeResourceUrl) ? bonus.extraLargeResourceUrl : bonus.resourceUrl,
                    isFree: bonus.isFree,
                    isShop: bonus.isShop,
                    includedPaymentMethodIds: bonus.paymentMethodIds,
                    depositBonus: depositBonus
                });
            }
        });
    }

    function updateAmount(amount) {
        controller.trigger(paymentEvent.UPDATE_AMOUNT, {
            amount: amount
        });
    }

    var startDepositClass = {
        createInstance: function(parameters){
            var deposit = {
                startDeposit: function () {
                    var $depositController = start();
                    if (parameters.isInGameDeposit === 'true') {
                        $depositController.trigger('IS_INSTANT_DEPOSIT');
                    } else {
                        $depositController.trigger('IS_NORMAL_DEPOSIT');

						$depositController.boxes[1].model.chosenBonusId = parameters.bonusId ? parameters.bonusId : "";
                    }
                    hideLicenceAboutUs();
                    return $depositController;
                },
                start: function () {
                    if (session.authenticated) {
                        return deposit.startDeposit();
                    } else {
                        return loginController.startLoginClass.createInstance(parameters, deposit.startDeposit).start(function () {
                            // The close when login done is here empty since we immediately want to continue with startDeposit function.
                        });
                    }
                },
                args: function () {
                    return undefined;
                }
            };
            return deposit;
        },
        createHashTag: function(params) {
            return this.baseHashTag + '$isInGameDeposit=' + params.isInGameDeposit + '&bonusId=' + params.bonusId;
        },
        baseHashTag: 'deposit'
    };

    var startInstantDepositClass = {
        createInstance: function(parameters) {
            var instantDeposit = {
                startInstantDeposit: function () {
                    var $depositController = start();
                    updateAmount(parameters.amount);
                    $depositController.trigger(paymentEvent.IS_INSTANT_DEPOSIT);
                    return $depositController;
                },
                start: function () {
                    if(session.authenticated){
                        return instantDeposit.startInstantDeposit();
                    } else{
                        return loginController.startLoginClass.createInstance(undefined, instantDeposit.startInstantDeposit).start(function(){
                            // The close when login done is here empty since we immediately want to continue with startInstantDeposit function.
                        });
                    }
                },
                args: function () {
                    return undefined;
                }
            };
            return instantDeposit;
        },
        createHashTag: function(params) {
            return this.baseHashTag + '$amount=' + params.amount;
        },
        baseHashTag: 'instantDeposit'
    };


    var startDepositBonusClass = {
        createInstance: function(parameters){
            var depositBonus = {
                startDepositBonus: function(){
                    var $depositController = start(1);
						selectBonus(parameters.bonusId);
                    $depositController.trigger(paymentEvent.IS_NORMAL_DEPOSIT);
                    return $depositController;
                },
                start: function(){
                    if(session.authenticated){
                        return depositBonus.startDepositBonus();
                    } else{
                        return loginController.startLoginClass.createInstance(undefined, depositBonus.startDepositBonus).start(function(){
                            // The close when login done is here empty since we immediately want to continue with startDepositBonus function.
                        });
                    }
                },
                args: function(){
                    return {
                        closePanelRedirectUrl: parameters.closePanelRedirectUrl
                    };
                }
            };
            return depositBonus;
        },
        createHashTag: function(params) {
            return this.baseHashTag + '$' + $.param(params);
        },
        baseHashTag: 'depositBonus'
    };

    function hideLicenceAboutUs(){
        var $MGAlogo=$('#start-bottom-menu').find('.logos');
        $MGAlogo.hide();
        $MGAlogo.next().hide();
    }

    return {
        start: start,
        startDepositClass: startDepositClass,
        startInstantDepositClass: startInstantDepositClass,
        startDepositBonusClass: startDepositBonusClass,
        trigger: function(event) {
            controller.trigger(event);
        }
    };
});

